export default __webpack_public_path__ + "static/media/grid.27e13d4e.svg";